module.exports = __webpack_public_path__ + "img/limpezaImage.7bf1a52b.svg";